import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import axios from 'axios';

import { showLoading, hideLoading } from "react-redux-loading-bar";
import { showInfoBox, hideInfoBox } from "../../components/InfoBox/actions.js";

import { setEditPortletData } from "../../actions/EditPortletDataActions.js";

import { get_FetchPortletList, get_GetPortlet } from "../../config/urls.js";

import Paginator from '../../components/paginator/index.js';

import { dateFromTimestamp, timeFromTimestamp } from "../../utils/format.js";

import { getXSRFToken } from "../../utils/xsrf-token-header";

import PortletModal from './components/PortletModal/index.js';

import './index.css';
class PortletsPage extends Component {

  constructor() {
    super();

    this.state = {
      fetchingPortletList: true,
      errorFetchingList: false,
      portletList: [],

      updatingTable: false,
      tablePageSize: 10,
      tableNumOfPages: 1,
      activePageNum: 1,
      tableTotalEntries: 0,


      modal_show: false,
      modal_portletData: false,
    }

    this.renderLoadingMessage = this.renderLoadingMessage.bind(this);
    this.renderErrorMessage = this.renderErrorMessage.bind(this);
    this.renderNoPortletsMessage = this.renderNoPortletsMessage.bind(this);
    this.renderPortletsTable = this.renderPortletsTable.bind(this);
    // this.renderLoadingMessage = this.renderLoadingMessage.bind(this);

    this.fetchPortletList = this.fetchPortletList.bind(this);
    this.retryFetchButtonHandler = this.retryFetchButtonHandler.bind(this);
    this.goToPage = this.goToPage.bind(this);

    this.addPortletButtonHandler = this.addPortletButtonHandler.bind(this);
    this.portletSelectHandler = this.portletSelectHandler.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.editButtontHandler = this.editButtontHandler.bind(this);

  }

  componentDidMount() {
    this.fetchPortletList();
  }

  render() {
    let content = null;

    let state = this.state;

    if (this.state.fetchingPortletList) {
      content = this.renderLoadingMessage();
    } else if (!state.fetchingPortletList && state.errorFetchingList) {
      content = this.renderErrorMessage();
    } else if (!state.fetchingPortletList && !state.errorFetchingList && state.portletList.length < 1) {
      content = this.renderNoPortletsMessage();
    } else if (state.portletList.length > 0) {
      content = this.renderPortletsTable();
    }

    return (
      <div className="portlets_route_wrapper">

        {this.state.modal_show && (
          <PortletModal
            portletData={this.state.modal_portletData}
            buttonHandler={this.closeModal}
          />
        )}

        <div className="navbar_root">

          <div className="aligner"></div>

          <div className="route_title">Portlets</div>

          <div className="profile_controls_wrapper"></div>

        </div>


        <div className="elevated_container">

          <div className="elevated_header">

            <div className="title">
              <div className="top">Available Portlets</div>
              <div className="bot">A complete list of all the portlets currently available</div>
            </div>


            <div className="button_area">
              <div className="button" onClick={this.addPortletButtonHandler}>+ Add Portlet</div>
            </div>
          </div>

          <div className="elevated_content">
            {content}
          </div>

        </div>
      </div>
    );
  }

  renderLoadingMessage() {
    return (
      <div className="info_message">
        Fetching List of currently active Portlets...
      </div>
    );
  }

  renderErrorMessage() {
    return (
      <div className="info_message">
        Error fetching Portlets list. <label onClick={this.retryFetchButtonHandler}>Try again</label>
      </div>
    );
  }

  renderNoPortletsMessage() {
    return (
      <div className="info_message">
        Fetching List of currently active Portlets...
      </div>
    );
  }

  renderPortletsTable() {

    const tableEntries = this.state.portletList.map((item, index) => {
      let num = (this.state.activePageNum - 1) * this.state.tablePageSize + index + 1;
      return (
        <tr key={index}>
          <td className="align_left">{num}</td>
          <td className="align_left">{item.name}</td>
          <td className="align_left">{item.appId}</td>
          <td className="align_left">{item.spa ? 'Yes' : 'No'}</td>

          <td className="" >
            {dateFromTimestamp(item.createdOn)}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {timeFromTimestamp(item.createdOn)}
          </td>

          <td className="">
            {item.updatedOn ? dateFromTimestamp(item.updatedOn) : '-'}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {item.updatedOn ? timeFromTimestamp(item.updatedOn) : ''}
          </td>

          <td>
            <div
              className="view_portlet_button"
              onClick={() => { this.portletSelectHandler(item) }}
            >
              {viewIcon}
            </div>

            {!item.system && (
              <div onClick={(evt) => { this.editButtontHandler(item.portletId, evt) }} className="edit_portlet_button">Edit</div>
            )}   
            
          </td>
        </tr>
      );
    });

    return (
      <div className="table_content">

        <div className="table_wrap">
          <table className="proper_table">
            <thead>
              <tr>
                <td className="align_left">No</td>
                <td className="align_left">Name</td>
                <td className="align_left">AppID</td>
                <td className="align_left">SPA</td>
                <td className="">Created (DD/MM/YY)</td>
                <td className="">Modified (DD/MM/YY)</td>
                <td className=""></td>
              </tr>
            </thead>

            <tbody>
              {tableEntries}
            </tbody>
          </table>

          {this.state.updatingTable && (
            <div className="loader">
              <div className="aligner"></div>
              <label>Updating...</label>
            </div>
          )}


        </div>

        <div className="table_controls">

          <div className="table_details">Total Entries: {this.state.tableTotalEntries}</div>

          <div className="paginator_area">
            <Paginator count={this.state.tableNumOfPages} activeButton={this.state.activePageNum} onClick={this.goToPage} />
          </div>

        </div>

      </div >
    );
  }


  fetchPortletList() {
    this.props.showLoading();

    this.setState({ fetchingPortletList: true, errorFetchingList: false }, () => {

      const requestTool = axios.create({
        timeout: 60000,
        headers: {
          ...getXSRFToken()
        }
      });

      let params = {
        pageNum: 1,
        pageSize: this.state.tablePageSize
      }

      requestTool.get(get_FetchPortletList, { params: params })
        .then((res) => {
          this.props.hideLoading();
          let data = res.data;

          let portletList = data.content;
          let portletNumber = data.count;

          let tableNumOfPages = Math.ceil(portletNumber / this.state.tablePageSize);


          this.setState({
            fetchingPortletList: false,
            portletList: portletList,
            tableNumOfPages: tableNumOfPages,
            tableTotalEntries: portletNumber
          });

        })
        .catch((err) => {
          // console.log(err.data);

          this.props.hideLoading();

          if (!err.data) {
            this.props.showInfoBox('Error processing request. Please try again', 'error', 3000);
            this.setState({
              fetchingPortletList: false,
              errorFetchingList: true
            });
            return;
          }

        });

    });
  }

  retryFetchButtonHandler() {
    this.fetchPortletList();
  }

  goToPage(pageNum) {
    this.props.showLoading();
    this.setState({ updatingTable: true }, () => {

    });

    const requestTool = axios.create({
      timeout: 60000,
      headers: {
        ...getXSRFToken(),
        'Content-Type': 'application/json'
      }
    });

    let params = {
      pageNum: pageNum,
      pageSize: this.state.tablePageSize
    };

    requestTool.get(get_FetchPortletList, { params: params })
      .then((res) => {

        this.props.hideLoading();
        let data = res.data;

        let portletList = data.content;


        this.setState({
          portletList: portletList,
          activePageNum: pageNum,
          updatingTable: false
        });

      })
      .catch((err) => {
        this.props.hideLoading();
        this.props.showInfoBox('Error processing request. Please try again', 'error', 3000);
        this.setState({ updatingTable: false });
      });
  }

  addPortletButtonHandler() {
    const hist = this.props.history;
    hist.push('/portlets/create');
  }

  portletSelectHandler(portletData) {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    this.setState({
      modal_show: true,
      modal_portletData: portletData
    });
  }

  closeModal() {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    this.setState({
      modal_show: false,
    });
  }

  editButtontHandler(portal_id, evt) {

    evt.stopPropagation();
    this.props.showLoading();
    this.props.hideInfoBox();

    const requestTool = axios.create({
      timeout: 60000,
      headers: {
        ...getXSRFToken()
      }
    });


    requestTool.get(get_GetPortlet(portal_id), {})
      .then((res) => {
        this.props.hideLoading();
        let data = res.data;

        this.props.setEditPortletData(data);

        const hist = this.props.history;
        hist.push('/portlets/update');

      })
      .catch((err) => {
        // console.log(err.data);

        this.props.hideLoading();

        if (!err.data) {
          this.props.showInfoBox('Error processing request. Please try again', 'error', 5000);
        }

      });
  }
}

const mapStateToProps = (state) => {
  return {
    editPortletData: state.editPortletData
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),

    showInfoBox: (message, type, timeout) => dispatch(showInfoBox(message, type, timeout)),
    hideInfoBox: () => dispatch(hideInfoBox()),

    setEditPortletData: (val) => dispatch(setEditPortletData(val))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PortletsPage));



let viewIcon = (
  <svg x="0px" y="0px" viewBox="0 0 488.85 488.85">
    <g>
      <path d="M244.425,98.725c-93.4,0-178.1,51.1-240.6,134.1c-5.1,6.8-5.1,16.3,0,23.1c62.5,83.1,147.2,134.2,240.6,134.2   s178.1-51.1,240.6-134.1c5.1-6.8,5.1-16.3,0-23.1C422.525,149.825,337.825,98.725,244.425,98.725z M251.125,347.025   c-62,3.9-113.2-47.2-109.3-109.3c3.2-51.2,44.7-92.7,95.9-95.9c62-3.9,113.2,47.2,109.3,109.3   C343.725,302.225,302.225,343.725,251.125,347.025z M248.025,299.625c-33.4,2.1-61-25.4-58.8-58.8c1.7-27.6,24.1-49.9,51.7-51.7   c33.4-2.1,61,25.4,58.8,58.8C297.925,275.625,275.525,297.925,248.025,299.625z" />
    </g>
  </svg>
);


// WEBPACK FOOTER //
// ./src/routes/portlets/index.js